import { DealEntity } from '@lib/deals';
import vest, { enforce, test } from 'vest';

function hasDuplicatePerson(arr) {
  const seenIds = new Set();
  for (const obj of arr) {
    if (seenIds.has(obj.vtr_id)) {
      return true; // Found a duplicate ID
    }
    seenIds.add(obj.vtr_id);
  }
  return false; // No duplicate IDs found
}

export const C2PValidationSuite = vest.create(
  (companymapping) => {

    test('Mandatory', 'Company is required.', () => {
      enforce(companymapping?.buyers[0]?.vtr_id).isTruthy();
    });

    test('Mandatory', 'At least one Person is required.', () => {
      const person_data_array = (companymapping.associated_person as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
        
      enforce( companymapping.associated_person && person_data_array?.length > 0).isTruthy();
    });

    test('Mandatory', 'Invalid Person added', () => {
      const person_data_array = (companymapping.associated_person as Array<Partial<DealEntity>>);
      enforce( companymapping.associated_person && !person_data_array?.some((obj) => obj?.vtr_id === '')).isTruthy();
    });

    test('Mandatory', 'Duplicate Person Added', () => {
      const associatedPersons = Array.isArray(companymapping.associated_person)
        ? companymapping.associated_person.filter(Boolean)
        : [];
      enforce(!hasDuplicatePerson(associatedPersons)).isTruthy();
    });

    test('Mandatory', 'Maximum 25 Person can be associated at a time.', () => {
      const person_data_array = (companymapping.associated_person as Array<Partial<DealEntity>>)
        .filter(x => x)
        .map(x => (x.vtr_id ?? ''))
        .filter(x => x !== '');
      enforce(person_data_array?.length <= 25).isTruthy();
    });
  }
);
